<template>
  <a
    v-if="collection"
    @click="handleCollectionClick(collection.info.text, collection.id)"
    class="pointer text-center width-100"
    data-test-id="shop_link_sub-category-image"
  >
    <img
      :src="$utils.getCDNURL({ src: collection.info.image_url, w: 300, h: 350, q: 100, fit: 'crop' })"
      class="mb-15 img-entity overflow-hidden"
      :class="[`img-entity-${['none', 'retailer', 'round-sm'][index]}`]"
    />
    {{ collection.info.text }}
  </a>
</template>

<style scoped lang="scss">
a {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  &:not(.mobile) {
    margin-top: 10px;

    &:hover {
      cursor: pointer;
      opacity: 0.3;
    }
  }
  img {
    width: 100%;
    display: block;
    max-width: 218px;
    -o-object-fit: cover;
    object-fit: cover;
  }
}
</style>

<script>
export default {
  props: {
    collection: {
      type: Object,
      default: null,
    },
    index: {
      type: Number,
      default: 0,
    },
    parentCategoryLabel: {
      type: String,
      default: "",
    },
  },
  methods: {
    handleCollectionClick,
  },
};

function handleCollectionClick(collectionName, collectionId) {
  this.$router.push({
    name: "CollectionWithCategory",
    params: {
      categoryName: this.parentCategoryLabel,
      collectionName,
      collectionId,
    },
    query: {
      page: 1,
    },
  });
}
</script>
